<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>药房介绍</span>
        <span
          style="background-color: #ffecda;color:#f48a15;"
          class="status"
          v-if="detail.reviewed_status==1"
        >待审核</span>
        <span
          style="background-color: #e5f1e3;color: #669961;"
          class="status"
          v-if="detail.reviewed_status==2"
        >审核通过</span>
        <span
          style="background-color: #ffe4e4;color: #d76b59;"
          class="status"
          v-if="detail.reviewed_status==3"
        >审核不通过</span>
      </span>

      <el-button
        type="primary"
        style="width:92px;"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px;">
      <div class="container">
        <div class="itemtitle">物流介绍</div>
        <p class="grey">{{detail.logistics_desc}}</p>
        <div class="itemtitle">药房介绍</div>
        <div v-html="detail.content"></div>
         <div
            style="margin-top:40px"
            v-if="detail.status==2"
          >
            <el-button
              plain
              @click="examine(4)"
              style="width:100px"
              :disabled="module_id_array[0]?!module_id_array.includes('96'):false"
            >不通过</el-button>
            <el-button
              type="primary"
              @click="examine(3)"
              style="width:100px"
              :disabled="module_id_array[0]?!module_id_array.includes('96'):false"
            >通过</el-button>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
import platform from "../../../api/platform";
import axios from "../../../service/axios/axios";
import hospital from "../../../api/hospital";
import _ from "lodash";
export default {
  data() {
    return {
      detail: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取药品审核详情
    getHospitalDescAuthInfo() {
      let reviewed_id = this.$route.query.reviewed_id;
      this.axios
        .post("platform/hospital/getHospitalDescAuthInfo", { reviewed_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //审核
    examine(status) {
      let reviewed_id = this.$route.query.reviewed_id;
      let auth_status = status;
      let text = "";
      if (status == 3) {
        text = "未通过";
      } else {
        text = "通过";
      }
      this.$confirm(`是否审核${text}？`, "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = { reviewed_id, auth_status }
          this.axios.post('platform/hospital/auditHospitalDesc',data).then((res) => {
            if (res.code == 0) {
              this.$message.success(`介绍审核${text}!`);
              this.back();
            }
          });
        })
        .catch();
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getHospitalDescAuthInfo();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}


.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.grey{
  color: #333333;
}

.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
.pricebox {
  border: solid 1px #cfcece;
  height: 40px;
  line-height: 40px;
  border-top: 0px solid #fff;
  padding-left: 20px;
  box-sizing: border-box;
}
</style>